/**
 * @author heart
 * @description 图片文字滚动
 */
import React, {useEffect, useRef} from "react";
import "./main.css";
// function initialString(num) {
//   if (num === undefined) {
//     return "translateX(0.00%) translateZ(0px)";
//   }
//   return `translateX(${num}%) translateZ(0px)`;
// }
// const initWidth = [];
// const initSpeed = [];
// let parentWidth = [];
// let timer = null;
// const reg = /X\(\s*(\-*\d*\.*\d*)%/;
// let string = "";
// let animationTimer = null;
// let timeOutTimer = null;
// function addsSrollEvents(dom) {
//   if (dom === null) return;
//   // 给每个元素添加滚动事件
//   // speed决定速度
//   // for (let i = 0; i < dom.current.children.length; i++) {
//     // if (dom.current.children[i].style.transform === "") {
//     //   dom.current.children[i].style.transform = initialString();
//     // } else {
//     //   string = dom.current.children[i].style.transform;
//     //   if (reg.test(string)) {
//     //     const num = Number.parseFloat(RegExp.$1) - initSpeed[i];
//     //     dom.current.children[i].style.transform = initialString(
//     //       num < initWidth[i] ? parentWidth[i] : num
//     //     );
//     //   }
//     // }
//   // }
//
//   timeOutTimer = setTimeout(() => {
//     animationTimer = requestAnimationFrame(() => {
//       addsSrollEvents(dom);
//     });
//   }, 30);
// }
// // 初始化计算滚动的宽度
// function initScrollWidth(dom, speed) {
//   if (dom === null) return;
//   // parentWidth = Number.parseFloat(dom.current.offsetWidth);
//   for (let i = 0; i < dom.current.children.length; i++) {
//     const childrenWidth = Number.parseFloat(
//       dom.current.children[i].offsetWidth
//     );
//     // 百分比以自身为中心
//     const childrenLeft = Number.parseFloat(dom.current.children[i].offsetLeft);
//     const childRight =
//       Number.parseFloat(dom.current.scrollWidth) -
//       Number.parseFloat(dom.current.children[i].offsetLeft) -
//       childrenWidth;
//     initWidth.push(
//       (((childrenLeft + childrenWidth) * 100) / childrenWidth) * -1
//     );
//     // 速度
//     initSpeed.push(speed / childrenWidth);
//     parentWidth.push((childRight * 100) / childrenWidth);
//   }
// }
// function clearScrollEvent() {
//   if (timer) {
//     clearInterval(timer);
//   }
// }
// const SrcollComponent = function (props) {
//   const { listImg = [] } = props;
//   const refContainer = useRef(null);
//   useEffect(() => {
//     initScrollWidth(refContainer, props.speed);
//   }, [props.speed, props.listImg.length]);
//   useEffect(() => {
//     addsSrollEvents(refContainer);
//     return () => {
//       clearScrollEvent(refContainer);
//     };
//   }, []);
//   return (
//     <>
//       <ul
//         className="flex  overflow-hidden position-relative text-align-center width-full flex-no-warp height-full"
//         ref={refContainer}
//         onMouseEnter={() => {
//           if (animationTimer) {
//             window.cancelAnimationFrame(animationTimer);
//             timeOutTimer && clearTimeout(timeOutTimer);
//             animationTimer = null;
//             timeOutTimer = null;
//           }
//         }}
//         onMouseLeave={() => {
//           if (animationTimer === null) {
//             requestAnimationFrame(() => {
//               addsSrollEvents(refContainer);
//             });
//           }
//         }}
//       >
//         {listImg.map((x, index) => {
//           return (
//             <li key={index} className="flex-1">
//               {x}
//             </li>
//           );
//         })}
//       </ul>
//     </>
//   );
// };
//


function initialString(num) {
  if (num === undefined) {
    return "translateX(0) translateZ(0)";
  }
  return `translateX(${num}%) translateZ(0)`;
}


let len = 0; //记录滚动的dom的下标
let animationTimer = null
let totalLength = 0;
const initWidth = [];
const initSpeed = [];
const reg = /X\(\s*(-?\d*(\.*\d*)?)%/;
const initScrollLength = []; //滚动边界
// 所有的都先移动到9999 初始化滚动
function initScroll(dom, speed) {
  initWidth.push(-((totalLength / dom.offsetWidth) + 1) * 100)
  initScrollLength.push(-((dom.offsetLeft / dom.offsetWidth) + 1) * 100)
  initSpeed.push(speed / dom.offsetWidth)
  initOffsetLeft(dom)

}

function initOffsetLeft(dom) {
  const width = totalLength - dom.offsetLeft
  dom.setAttribute('style', `transform:translateX(${(width / dom.offsetWidth) * 100}%) translateZ(0)`)
}


let scrollWidth = 0;

function singleScroll(dom) {
  scrollWidth = dom.current.children[len].getAttribute('style')
  if (reg.test(scrollWidth)) {
    if (RegExp.$1 < (initScrollLength[len])) {
      initOffsetLeft(dom.current.children[len])
      len++;
      if (len > dom.current.children.length - 1) {
        len = 0;
      }
    } else {
      dom.current.children[len].style.transform = initialString(RegExp.$1 - initSpeed[len]);
    }
  }
  animationTimer = requestAnimationFrame(() => {
    singleScroll(dom)
  })
}


const SrcollComponent = function (props) {
  const refContainer = useRef(null)

  const {listImg = []} = props;

  useEffect(() => {
    len = 0;
    if (props.listImg.length > 0) {
      totalLength = refContainer.current && refContainer.current.offsetWidth // 总长度
      if (refContainer.current.children) {
        for (let i = 0; i < refContainer.current.children.length; i++) {
          initScroll(refContainer.current.children[i], props.speed)
        }
        singleScroll(refContainer)
      }
    }
  }, [props.listImg.length, props.speed])

  return (
    <>
      <ul
        className="flex  overflow-hidden position-relative text-align-center width-full flex-no-warp height-full"
        ref={refContainer}
        onMouseEnter={() => {
          if (animationTimer) {
            window.cancelAnimationFrame(animationTimer);
            animationTimer = null;
          }
        }}
        onMouseLeave={() => {
          if (animationTimer === null) {
            requestAnimationFrame(() => {
              singleScroll(refContainer);
            });
          }
        }}
      >
        {listImg.map((x, index) => {
          return (
            <li key={index} className="flex-1">
              {x}
            </li>
          );
        })}
      </ul>
    </>
  );
}

export default SrcollComponent;
